export default __webpack_public_path__ + "static/media/to_do.1ef9df59.png";